<script>
	import { isSuit } from '../types';
	import { getSuitColor } from '../helpers';
	import { getNewIcon } from '../../card_images';
	import SuitChip from '../chips/SuitChip.svelte';
	import TraitChip from '../chips/TraitChip.svelte';
	import OperationText from '../ops/OperationText.svelte';

	export let row; // A bot chart entry from $res.botCharts
	export let text;

	$: suit = isSuit(row.icon) ? row.icon : null;
	// 'non-[[borg]]' as one chip: loose 'non-' text would sit on the black stripe
	$: nonTrait = (row.origIcon.match(/^non-\[\[([^\]]+)\]\]$/) || [])[1];

	// Borg Queen sync levels go greener as more are deployed
	const syncColors = ['#aaaaaa', '#a5bba5', '#99cc99', '#82cc82', '#77bb77', '#60aa60', '#33aa33'];
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
{#if row.syncLevel}
	<div class="suit-effect sync" style="--c:{syncColors[row.syncLevel - 1] || '#33aa33'}" on:click>
		<div class="suit-stripe font-block">{row.syncLevel}</div>
		<div class="suit-bg"></div>
		<div class="op sync-op">
			<OperationText {text} color="black" size={14} />
		</div>
	</div>
{:else if suit}
	<div class="suit-effect" style="--c:{getSuitColor(suit, true)}" on:click>
		<div class="suit-stripe"><img src={getNewIcon(suit)} alt={suit} /></div>
		<div class="suit-bg"></div>
		<div class="op">
			<SuitChip {suit} botLabel />
			<OperationText {text} color="black" size={14} />
		</div>
	</div>
{:else}
	<div class="trait-effect" on:click>
		<div class="trait-stripe"></div>
		<div class="op">
			{#if nonTrait}
				<span class="op-key" style="font-size: calc(var(--height) / {401 / 15});"><TraitChip trait={nonTrait} prefix="non-" /></span>
			{:else}
				<OperationText text={row.origIcon} color="black" size={15} />
			{/if}
			<OperationText {text} color="black" size={14} />
		</div>
	</div>
{/if}

<style lang="scss">
	.suit-effect, .trait-effect {
		position: relative;
		flex-shrink: 0;
	}
	.trait-effect {
		padding: calc(var(--u) * 4) 0;
		align-items: center;
	}
	.op {
		display: inline;
		padding: calc(var(--u) * 5) calc(var(--u) * 4) calc(var(--u) * 5) 0;
		text-indent: -1.5em;
		margin-left: 2.5em;
		z-index: 2;
	}
	.sync:not(:last-of-type) {
		border-bottom: 1px solid black;
	}
	.sync-op {
		text-indent: 0;
	}
	.trait-effect .op {
		padding: 0 calc(var(--u) * 4) 0 0;
	}
	.suit-stripe, .trait-stripe {
		position: absolute;
		left: 0;
		top: 0;
		width: 2em;
		height: 100%;
		z-index: 1;
	}
	.suit-stripe {
		z-index: 3; // Above .op so the bot-label chip tucks under it
		background-color: var(--c);
		justify-content: center;
		align-items: center;
		& > img {
			filter: brightness(0) invert(1);
			width: 70%;
		}
	}
	.trait-stripe {
		background-color: black;
		border-radius: 0 calc(var(--u) * 8) calc(var(--u) * 8) 0;
	}
	.suit-bg {
		position: absolute;
		inset: 0;
		background-color: var(--c);
		opacity: 0.15;
	}
</style>
